module.exports = __webpack_public_path__ + "media/images/lp_counseling_sumaho-788a12d32e76f89e5c045c94e9211d2f.png";